import {Component, OnInit, ViewChild} from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AppState } from '@app/app.service';
// import {LoginInfoComponent} from "../../user/login-info/login-info.component";
import { Subscription } from 'rxjs';
import { LayoutService} from "@app/shared/layout/layout.service";

import { CommonService } from '@app/shared/common/common.service';
import { NavigationService } from './navigation.service';

import { I18nService } from '@app/shared/i18n';
import moment from 'moment';
// import { LandingService } from '@app/features/ebill/landing/landing.service';
import { NumberPipe } from '@app/shared/pipes/number.pipe';

declare var $: any;
@Component({

  selector: 'sa-navigation',
  templateUrl: './navigation.component.html',
  styleUrls:['./navigation.component.scss'],
  providers: [NumberPipe],
})
export class NavigationComponent implements OnInit {
  appCode: string;
  appDataSubscription: Subscription;
  langDataSubscription: Subscription;
  navData: any;
  navigationList: any;
  isNavLoading: boolean;
  appId: number;
  navigationData: any = {};
  settingsNavigationData: any;
  showDefault: boolean;
  appPath: string;
  reloadNav:boolean=true;
  language:string="";
  appDetail: {};
  hasTicketRights:boolean = false;

  constructor(private router: Router, private navService: NavigationService,
    private layoutService: LayoutService, private commonService: CommonService,private i18n:I18nService) {
    this.navigationList = [];
    this.navData = [];
    this.settingsNavigationData = {};
    

    if(localStorage.getItem('appDetail')){
      this.appDetail = JSON.parse(localStorage.getItem('appDetail'));
      this.appId = this.appDetail['id'];
    }
    this.setNavid('init','',JSON.parse(localStorage.getItem('appDetail')));
    $("body li").first().addClass("active");
    if(this.router.url.indexOf("/settings/") == -1){
    }
    // $(document).on('mouseenter', ".menuTooltip", function () {
    //   var $this = $(this);
    //   if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
    //       $this.tooltip({
    //           title: $this.text(),
    //           placement: "top"
    //       });
    //       $this.tooltip('show');
    //   }
    // });
    $('.menu-item-parent').css('width',$('.menu-item-parent').parent().width());
    var self=this
    // $('body').off('mouseenter', '.helpSection').on('mouseenter', '.helpSection', function (event) {
    //   event.stopPropagation();
    
    //   $(this).append(
    //     "<p class='idTooltipHelpdesk'>" +
    //     "<span class='insideDivUl-nohover'>" + self.i18n.getTranslation('invoice_Helpdesk_not_available_demo_version') + "</span>" +
    //     "</p>");
    // });
    $('body').off('mouseleave', '.helpSection').on('mouseleave', '.helpSection ', (event) => {
      $(event.currentTarget).parent().find(".idTooltipHelpdesk").remove();
    });

    // let rights =  this.commonService.getCookie(environment.userRights) ? 
    //               JSON.parse(this.commonService.decrypt(decodeURIComponent(this.commonService.getCookie(environment.userRights)))).userRights :
    //               this.commonService.logout();
    let rights = localStorage.getEncryptedItem('userRights')

    let rightsArray = rights.split(',')  
    this.hasTicketRights = rightsArray.includes('ngtATicket_Create ');
  }
  resetData() {
    this.navigationList = [];
  }
  getNavigation() {
        if(!($.isEmptyObject(this.navigationData))){
            this.saveTreeData(this.navigationData[this.appId]);
        }
  }
  
  ngOnInit() {
    this.language=this.i18n.currentLanguage.key;
    let init=true;
    this.langDataSubscription=this.i18n.getEmittedLanguageValue().subscribe(item => {
        this.language=item.key;
        this.getSettingsNavigationDataTemp();
        this.getNavigationTemp();
    });
    this.appDataSubscription = this.layoutService.subscribeAppDataChange((data:any) => {
      let appCode = data.code;
      this.appId = data.id;
      this.appPath = data.path;
      this.showDefault = data.showDefault;
      if (this.appCode !== appCode || this.appId!=undefined) {
        this.appCode = appCode;
        if (this.appCode !== 'settings') {
            this.getNavigation();
          $('body').removeClass('setting-menu');
        } else {
          this.getSettingsNavigationData();
          $('body').addClass('setting-menu');
        }
      }
      this.setNavid('init','',JSON.parse(localStorage.getItem('appDetail')));
    }); 
    // this.getUserSettings()
  }
  getSettingsNavigationDataTemp(){
    let data = new FormData();
      data.append('instanceId',localStorage.getEncryptedItem('instanceId'));
      data.append('companyUserId',localStorage.getEncryptedItem('companyUserId'));
      data.append('language',this.language);
      data.append('module','archive');
      data.append('userId',localStorage.getEncryptedItem('loginId'));
      data.append("loggedInTime", localStorage.getEncryptedItem("loggedInTime"));
      data.append("lastRequestTime", localStorage.getEncryptedItem("lastRequestTime"));
      let object = this.commonService.createObject(data)
      let token = this.commonService.createToken(object)
      let encryptedToken = this.commonService.encrypt(token)
      let encrData = new FormData()
      encrData.append("encrToken", encryptedToken);
      this.navService.fetchSettingsNavigationData(encrData).subscribe((data:any) => {    
        if(!data.status && data.isUnauthenticated) {
          this.commonService.logout();
          
          return false;
        }
        localStorage.setEncryptedItem("lastRequestTime",data.RESPONSETIME);
        var keys = Object.keys(data.DATA)
        let key=keys[0];
        this.settingsNavigationData = data.DATA[key];
        localStorage.setEncryptedItem('settings',JSON.stringify(this.settingsNavigationData));
        if (this.appCode == 'settings') {
          this.saveTreeData(this.settingsNavigationData);
        }else{
          this.saveTreeData(this.navigationData[this.appId]);
        }
      });
  }
  getNavigationTemp(){
    let data = new FormData();
      data.append('instanceId',localStorage.getEncryptedItem('instanceId'));
      data.append('companyUserId',localStorage.getEncryptedItem('companyUserId'));
      data.append('language',this.language);
      data.append('userId',localStorage.getEncryptedItem('loginId'));
      data.append("loggedInTime", localStorage.getEncryptedItem("loggedInTime"));
      data.append("lastRequestTime", localStorage.getEncryptedItem("lastRequestTime"));
      let object = this.commonService.createObject(data)
      let token = this.commonService.createToken(object)
      let encryptedToken = this.commonService.encrypt(token)
      let encrData = new FormData()
      encrData.append("encrToken", encryptedToken);
      this.navService.fetchNavigationData(encrData).subscribe((data:any) => {
        if(!data.status && data.isUnauthenticated) {
          this.commonService.logout();         
          return false;
        }
        localStorage.setEncryptedItem("lastRequestTime",data.RESPONSETIME);
        if (data.STATUS && data.DATA) {
          this.navigationData = data.DATA;
        }
        if (this.appCode == 'settings') {
          this.saveTreeData(this.settingsNavigationData);
        }else{
          this.saveTreeData(this.navigationData[this.appId]);
        }
      });

  }

  ngOnDestroy() {
    this.appDataSubscription.unsubscribe();
    this.langDataSubscription.unsubscribe();
  }

  getSettingsNavigationData() {
        if(!($.isEmptyObject(this.settingsNavigationData))){
          this.saveTreeData(this.settingsNavigationData);
        }
  } 

  saveTreeData(data) {
    this.isNavLoading = true;
    let navData = this.manipulateTreeData(data);
    this.navigationList =  navData; 
    if(this.showDefault){
        if(this.appPath==""|| this.appPath==undefined){
          this.navigateTreeToDefaultPath();
        }
        else{
          this.router.navigateByUrl(this.appPath)
        }
    }
    setTimeout(() => {
      this.isNavLoading = false;
    },10)
    this.setNavid('init','',JSON.parse(localStorage.getItem('appDetail')));
  }

  private isLookAndFeelSettingsNode(node: any): boolean {
    const modulePath = (node?.MODULE || '').toString().toLowerCase();
    return modulePath.includes('/settings/lookandfeel');
  }

  manipulateTreeData(tree) {
    let arrTree = [];
    let sortedArr = [];
    let retSortedArr = [];
    for (let i in tree) {
      let node = tree[i];
      if(typeof node === 'object'){
        let manipulatedNode = this.manipulateSettingsNode(node);
        if (this.isLookAndFeelSettingsNode(manipulatedNode)) {
          continue;
        }
        arrTree.push(manipulatedNode);
        let pos = manipulatedNode['POS'];
        if (pos) {
          pos = parseInt(pos);
          sortedArr[pos] = manipulatedNode;
        }
      }  
    }
    for (let j in sortedArr) {
      if (sortedArr[j]) {
        retSortedArr.push(sortedArr[j]);
      }
    }
    if (arrTree.length === retSortedArr.length) {
      return retSortedArr;
    }
    return arrTree;
  }

  manipulateSettingsNode(node) {
    let manipulatedNode = {
      children: []
    };
    let sortedNode = {
      children: []
    };
    let retSortedNode = {
      children: []
    };
    for (let i in node) {
      let childData = node[i];
      if (typeof (childData) === 'object') {
        let gManiuplatedNode = this.manipulateSettingsNode(childData);
        if (!this.isLookAndFeelSettingsNode(gManiuplatedNode)) {
          manipulatedNode.children.push(gManiuplatedNode);
          let pos = gManiuplatedNode['POS'];
          if (pos) {
            pos = parseInt(pos);
            sortedNode.children[pos] = gManiuplatedNode;
          }
        }
      } else {
        manipulatedNode[i] = childData;
        sortedNode[i] = childData;
        retSortedNode[i] = childData;
      }
    }
    for (let j in sortedNode.children) {
      if (sortedNode.children[j]) {
        retSortedNode.children.push(sortedNode.children[j]);
      }
    }
    if (manipulatedNode.children.length === retSortedNode.children.length) {
      return retSortedNode;
    }
    return manipulatedNode;
  }

  getDefaultPathForTree(settingsList) {
    let defaultPath = "";
    for (let i = 0; i < settingsList.length; i++) {
      let node = settingsList[i];
      if (node.MODULE !== "") {
        defaultPath = node.MODULE;
        break;
      }
      for (let j = 0; j < node.children.length; j++) {
        let cNode = node.children[j];
        if (cNode.MODULE !== "") {
          defaultPath = cNode.MODULE;
          break;
        }
        for (let k = 0; k < cNode.children.length; k++) {
          let gNode = cNode.children[k]
          if (gNode.MODULE !== "") {
            defaultPath = gNode.MODULE;
            break;
          }
        }
        if (defaultPath !== "") {
          break;
        }
      }
      if (defaultPath !== "") {
        break;
      }
    }
    return defaultPath;
  }

  navigateTreeToDefaultPath() {
    console.log(this.navigationList);
    let defaultPath = this.getDefaultPathForTree(this.navigationList);
    if (defaultPath) {
      this.router.navigateByUrl(defaultPath.substring(1,defaultPath.length));
    } 
  }
  setNavid(data,module,appDetail,node?){
    if(node){
      if(node.children.length === 1){
        data = node.children[0].ID;
        module = node.children[0].MODULE;
        if(module)
        this.router.navigate([module]);
      }
    }
    var tempNavId = '';
    if(data == 'init'){
      if(this.navigationList.length != 0){
        this.navigationList.forEach(element => {
          if(element.children.length > 0){
            element.children.forEach(ele => {
              if(ele.children.length > 0){
                ele.children.forEach(e => {
                  if(e.children.length>0){
                    e.children.forEach(el => {
                      if(el.MODULE == window.location.pathname){
                        this.layoutService.setNavId(el.ID,el.MODULE);
                      }
                    });
                  }
                  if(e.MODULE == window.location.pathname){
                    this.layoutService.setNavId(e.ID,e.MODULE);
                  }
                });
              }
              if(ele.MODULE == window.location.pathname){
                this.layoutService.setNavId(ele.ID,ele.MODULE);
              }
            });
          }
          if(element.MODULE == window.location.pathname){
            this.layoutService.setNavId(element.ID,element.MODULE);
          }
        });
      }
      else if(appDetail){
        this.layoutService.setNavId(appDetail.id,appDetail.path);
      }
    }
    else if(module != ''){
      this.layoutService.setNavId(data,module)

    }
  }
  getUserSettings() {
    let formData = new FormData();
    formData.append('instanceId', localStorage.getEncryptedItem("instanceId"))
    formData.append('companyUserId', localStorage.getEncryptedItem("companyUserId"))
    formData.append('module', 'invoice')
    formData.append('userId',localStorage.getEncryptedItem('loginId'));
    formData.append("loggedInTime", localStorage.getEncryptedItem("loggedInTime"));
    formData.append("lastRequestTime", localStorage.getEncryptedItem("lastRequestTime"));
    let object = this.commonService.createObject(formData)  
    let token = this.commonService.createToken(object)
    let encryptedToken = this.commonService.encrypt(token)
    let data = new FormData()
    data.append("encrToken", encryptedToken); 
    this.navService.getModuleSettings(data).subscribe((data:any)=>{
      if(!data.status && data.isUnauthenticated) {
      this.commonService.logout();
      return false;
      }
      if(data.STATUS&&Object.keys(data.DATA).length != 0){
      let obj =data.DATA.SETTING;
      let menuExpand;
      obj.forEach(element => {
        if(Object.keys(element)[0] == 'menuExpand') {
          menuExpand = element['menuExpand']
        }
      });
        if(data.DATA.MODULE=="invoice" && menuExpand==1){
          this.layoutService.onMenuCollapse(true);
        }
        else{
          this.layoutService.onMenuCollapse(false);
        }
      }
      else {
        this.layoutService.onMenuCollapse(false);
      }
    })
    }
}
